import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanBEApi } from "~/Services";

interface DocumentDetailsResponse {
  id: any;
  epcId: string;
  epsId: string;
  epcType: string;
  epcStatus: string;
  epcExpiry: string;
  title: string;
  firstName: string;
  emailAddress: string;
  designation: string;
  nric: string;
  passportNumber: string;
  mobileNumber: string;
  homeNumberCountryCode: string;
  homeNumber: string;
  mailingAddress: string;
  postalCode: string;
  nationality: string;
  gender: string;
  maritialStatus: string;
  dateOfBirth: string;
  profession: string;
  incomeRange: string;
  promotions: any;
  promotionsEmail: any;
  epcUpgradationRequest: any;
  country: string;
  state: string;
  mobileNumberCountryCode: string;
  isForRenewal: boolean;
  epcCard: string;
  epcRenewalRequest: string;
}

// edit api call
const fetchEpcApplicationDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanBEApi.get(`/admin/epc/get?id=${id}`);
  return response.data;
};

const useEpcApplicationDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["epcApplicationDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchEpcApplicationDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useEpcApplicationDocumentDetails };
